<template>
  <div class="wrapper">


    <CRow>
      <CCol>
        <div class="card">
          <div class="card-body">
            <CRow>
              <CCol lg="4" >
                <div id="app">
                    <h5>{{currentDate()}}</h5>
                      <h2> {{ showTime }} </h2>
                  </div>
              </CCol>
              <CCol lg="4" class="mt-3 ">
                <CButton   class=" mt-2"  @click="openShow()"   color="info">Scan QR Code</CButton>
              </CCol>
            </CRow>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol >
            <div class="card">
              <div class="card-body">
                <h3> iKids Report </h3>
                <hr>
                  <div class="table-container">
                    <table class="table_ikid_report">
                    <thead>
                        <tr>
                          <th v-for="item in fieldsClass" :key="item.title">
                              {{ item.title }}
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in datas.data" :key="i.id">
                          <td>
                              {{ (i.name) }}
                          </td>
                          <td>
                              {{ (i.count_check_in) }}
                          </td>
                          <td>
                              {{ (i.count_queued) }}
                          </td>
                          <td>
                              {{ (i.count_check_out) }}
                          </td>
                          <td>
                              {{ (i.count2_check_in) }}
                          </td>
                          <td>
                              {{ (i.count2_queued) }}
                          </td>
                          <td>
                              {{ (i.count2_check_out) }}
                          </td>
                        </tr>
                        <tr>
                          <th >
                              {{ 'Total' }}
                          </th>
                          <th >
                              {{total_check_in}}
                          </th>
                          <th >
                              {{total_queued}}
                          </th>
                          <th >
                              {{total_check_out}}
                          </th>
                          <th >
                              {{total2_check_in}}
                          </th>
                          <th >
                              {{total2_queued}}
                          </th>
                          <th >
                              {{total2_check_out}}
                          </th>
                        </tr>
                    </tbody>
                    </table>
                  </div>
              </div>
            </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
          <div class="card">
            <div class="card-body">
                <Datatable
                    :items="items"
                    :listclass="listclass"
                    :fields="fields"
                    :meta="meta"
                    @per_page="handlePerPage"
                    @pagination="handlePagination"
                    @search="handleSearch"
                    @sort="handleSort"
                    @is_active="handleIsActive"
                    @status_filter="handleStatus"
                    @class_filter="handleClassFilter"
                    :btn_show="true"
                    :btn_edit="true"
                    :btn_deactivate="true"
                    :btn_reactivate="false"
                    :btn_delete="false"
                    :is_uuid="true"
                    @checkin="handleCheckin"
                    @present="handlePresent"
                    @checkout="handleCheckOut"
                    @forceCheckout="handleForceCheckOut"
                    @cancelStatus="handleCancelStatus"
                    @forceCancelStatus="handleForceCancelStatus"
                    @reprint="handleReprint"
                />
            </div>
          </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <div class="card">
            <div class="card-body">
              <DatatableLog
                  :items="itemsLog"
                  :fields="fieldsLog"
                  :meta="metaLog"
                  @per_page="handlePerPageLog"
                  @pagination="handlePaginationLog"
                  @sort="handleSort"
                  @is_active="handleIsActive"
                  :is_uuid="true"
              />
            </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <div class="card">
            <div class="card-body">
              <h3> iKids Report Attendance </h3>
              <!-- <CRow >
                <CCol sm="5" lg="4" >
                  <label class="mt-2"  > Report Date Month </label>
                  <b-form-select v-model="month" :options="options_month"></b-form-select>
                </CCol>
                <CCol sm="5" lg="4" >
                  <label class="mt-2"  > Report Date Year </label>
                  <b-form-select  v-model="year" :options="options_year"></b-form-select>
                </CCol>
              </CRow> -->

              <CRow >
                <CCol sm="5" lg="4" >
                  <label class="mt-2">Start Date</label>
                  <CInput  v-model="report_start_date" type="date" />
                </CCol>
                <CCol sm="5" lg="4" >
                  <label class="mt-2">End Date</label>
                  <CInput  v-model="report_end_date" type="date" />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="5" lg="4" >
                  <label class="mr-3">Class</label>
                  <select class="form-control" v-model="report_class_id">
                      <option value="0">Show All</option>
                      <option v-for="item in listclass" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </CCol>
                <CCol sm="5" lg="4" >
                  <label class="mr-3">Grade</label>
                  <select class="form-control" v-model="report_grade_id">
                      <option value="0">Show All</option>
                      <option v-for="item in listgrade" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                </CCol>
                <CCol sm="5" lg="4" >
                  <label class="mr-3">Service</label>
                  <select class="form-control" v-model="report_service_type">
                      <option value="0">Show All</option>
                      <option value="1">Service 1</option>
                      <option value="2">Service 2</option>
                  </select>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="5" lg="4" >
                  <CButton class="col-5 ml-3 mt-3 "  variant="outline" color="info" @click="showIkidMonthlyReportAttendance()">Monthly Report</CButton>
                </CCol>
              </CRow>
            </div>
        </div>
      </CCol>
    </CRow>
    <!-- <pre>{{ datas.data }}</pre> -->
      <ikidmodal_checkin></ikidmodal_checkin>
      <alertmodal></alertmodal>
  </div>
</template>

<script >
import Datatable from '@/components/datatables_ikid_check.vue'
import DatatableClass from '@/components/datatables_ikid_check_class.vue'
import DatatableLog from '@/components/datatables_ikid_check_log.vue'

import axios from 'axios'

import ikid from '@/services/ikid'
import ikidmodal_checkin from './ikidsmodal_checkin.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

import Pusher from 'pusher-js';
import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import QRCode from 'qrcode';

import moment from 'moment';

const token = localStorage.getItem('token');

export default {
  name: 'iKidsTable',
  components: { ikidmodal_checkin, alertmodal, Datatable,DatatableClass,DatatableLog },
  data(){
    const url = window.location.href;
    const index = url.indexOf('class=')
    let ikid_class_name = url.slice(index).split('=')[1] || ""

    //buat 1 kata class name menjadi huruf besar
    ikid_class_name = ikid_class_name.charAt(0).toUpperCase() + ikid_class_name.slice(1)


    return{
      form:{
        ikid_id:'',
        status:'',
        from:'portal',
      },
      showMilitary: false,
      showTime: '',
      now: new Date(),
      updateSubmit: false,
      largeModal:false,
      datas:[],
      fields: [
          {key: 'name', sortable: false, },
          {key: 'profilepic', sortable: false, },
          {key: 'class_name', sortable: false, },
          {key: 'dob', sortable: false, },
          {key: 'checkin_status', label:'Status', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      fieldsClass: [
            { title: "Class", sortable: false },
            { title: "In Service 1", sortable: false },
            { title: "Queued Service 1", sortable: false },
            { title: "Out Service 1", sortable: false },
            { title: "In Service 2", sortable: false },
            { title: "Queued Service 2", sortable: false },
            { title: "Out Service 2", sortable: false },
         ],
       fieldsLog: [
          {key: 'name', sortable: false, },
          {key: 'action', sortable: false},
          {key: 'log_time', sortable: false},
      ],
      listclass: [],
      listgrade: [],
      items: [],
      itemsLog: [],
      meta: [],
      metaLog: [],
      current_page: 1,
      per_page: 10,
      current_pageLog: 1,
      per_pageLog: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      sortByLog: 'log_time',
      sortByDescLog: true,
      is_active: 1,
      permission: true,
      checkin_status : 0,
      ikid_class_name: ikid_class_name || 0,
      kid_class_id : '',
      // messages: [],
      now_action: null,
      from: null,
      pusher_data: {
        kid_name: null,
        kid_class_id: null,
        now_action: null,
        from: null,
      },
      options_month: [
        {text:"", value: ""},
        {text: "January", value: "1"},
        {text: "February", value: "2"},
        {text: "March", value: "3"},
        {text: "April", value: "4"},
        {text: "May", value: "5"},
        {text: "June", value: "6"},
        {text: "July", value: "7"},
        {text: "August", value: "8"},
        {text: "September", value: "9"},
        {text: "October", value: "10"},
        {text: "November", value: "11"},
        {text: "December", value: "12"},

      ],
      options_year: [],
      name: '',
      report_class_id: 0,
      report_grade_id: 0,
      report_start_date: '',
      report_end_date: '',
      report_service_type: 0,
      //end
    }
  },

  created() {
      this.beforeDestroy()
  },

  async mounted (){

    // to fill ddl year 2000 - current year
    const currentYear = new Date().getFullYear();
    const startYear = 2000;
    const years = [];

    for (let i = currentYear; i >= startYear; i--) {
      years.push(i);
    }

    this.options_year = years;

     await this.loadClass()
     await this.loadGrade()
     this.loadData()


    EventBus.$on('TABLE_UPDATE_IKIDS_CHECK', (data) => {
      if(data){
          this.loadData();
      }
    });
    this.showTheTime()

    /*
    // Realtime disabled on this page. Use /ikids/kids-check-manual.
    // PUSHER START
    Vue.use(Toast)
    const pusher = new Pusher('fbb60f501f4a91119030', {
      cluster: 'ap1',
      encrypted: true
    });
    const channel = pusher.subscribe('kid-channel');
    channel.bind('status-change', (data) => {
      this.pusher_data.kid_name = data.kid_name
      this.pusher_data.kid_class_id = data.kid_class_id
      this.pusher_data.now_action = data.now_action
      this.pusher_data.from = data.from

      if (this.pusher_data.from == 'portal' && this.pusher_data.now_action == 'in class') {
        // this.$toast.success(this.pusher_data.kid_name + ' now In Class')
        this.loadData();
        this.loadClass()
      } else if (this.pusher_data.from == 'portal' && this.pusher_data.now_action == 'check in') {
        // this.$toast.success(this.pusher_data.kid_name + ' is Check Out')
        this.loadData();
        this.loadClass()
      } else if (this.pusher_data.from == 'portal' && this.pusher_data.now_action == 'check out') {
        // this.$toast.success(this.pusher_data.kid_name + ' is Check Out')
        this.loadData();
        this.loadClass()
      } else if (this.pusher_data.from == 'portal' && this.pusher_data.now_action == 'queued') {
        // this.$toast.success(this.pusher_data.kid_name + ' is Check Out')
        this.loadData();
        this.loadClass()
      }
      if (this.pusher_data.from == 'other' && this.pusher_data.now_action == 'check in') {
        // this.$toast.success(this.pusher_data.kid_name + ' is Check In')
        this.loadData();
        this.loadClass()
      } else if (this.pusher_data.from == 'other' && this.pusher_data.now_action == 'queued') {
        // this.$toast.success(this.pusher_data.kid_name + ' now In Queued')
        this.loadData();
        this.loadClass()
      }
    });
    channel.bind('status-cancel', (data) => {
      this.pusher_data.kid_name = data.kid_name
      this.pusher_data.kid_class_id = data.kid_class_id
      this.pusher_data.now_action = data.now_action
      this.pusher_data.from = data.from

      // this.$toast.warning(this.pusher_data.kid_name + ' cancel the status')
      this.loadData();
    });
    // PUSHER END
    */

   },

   computed: {
      total_check_in() {
        return this.datas.data.reduce((total, item) => {
          return total + Number(item.count_check_in)
        }, 0);
      },

      total_queued() {
        return this.datas.data.reduce((total, item) => {
          return total + Number(item.count_queued)
        }, 0);
      },

      total_check_out() {
        return this.datas.data.reduce((total, item) => {
          return total + Number(item.count_check_out)
        }, 0);
      },

      total2_check_in() {
        return this.datas.data.reduce((total, item) => {
          return total + Number(item.count2_check_in)
        }, 0);
      },

      total2_queued() {
        return this.datas.data.reduce((total, item) => {
          return total + Number(item.count2_queued)
        }, 0);
      },

      total2_check_out() {
        return this.datas.data.reduce((total, item) => {
          return total + Number(item.count2_check_out)
        }, 0);
      },

    },
  methods: {

    beforeDestroy(){
    EventBus.$off('OPEN_MODAL_IKID_CHECKIN', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_QUEUE', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_CHECKOUT', this.listener)
   },
   currentDate() {
    var  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      const current = new Date();
      const date = current.getDate() +' '+ months[current.getMonth()]+' '+current.getFullYear()
      return date;
    },
   showTheHours(theHour) {
      var vm = this
      if (vm.showMilitary|| (theHour > 0 && theHour < 13)) {
        if (theHour == "") theHour = 12;
        return (theHour);
      }
      if (theHour == 0) {
        return (12);
      }
      return (theHour);
    },
    showZeroFilled(inValue) {
      if (inValue > 9) {
        return "" + inValue;
      }
      return "0" + inValue;
    },
    showAmPm() {
      var vm = this
      if (vm.showMilitary) {
        return ("");
      }
      if (vm.now.getHours() < 12) {
        return (" AM");
      }
      return (" PM");
    },

    showTheTime() {
      var vm = this
      vm.now = new Date
      vm.showTime = vm.showTheHours(vm.now.getHours()) + ":" + vm.showZeroFilled(vm.now.getMinutes()) + ":" + vm.showZeroFilled(vm.now.getSeconds()) + vm.showAmPm()
      setTimeout(vm.showTheTime,1000)
    },
    openShow() {
        //  var params = { title: "Scan Kids" };
        //  this.$router.push({ name: "Kids Scan" });
        let routeData = this.$router.resolve({path: '/ikids/kids-scan'})
        window.open(routeData.href, '_blank');
      },
    openCheckin: function(uuid) {
      var params = {
            title: "Check In",
            mode: "detail",
            data: uuid
         };
         EventBus.$emit("OPEN_MODAL_IKID_CHECKIN", params);
    },
    openPresent: function(uuid) {
      if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 2;
        ikid.changeStatusKid(this.form)
        .then(res => {
        EventBus.$emit('TABLE_UPDATE_IKIDS_CHECK', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    // reprint(uuid) {
    //   this.form.ikid_id = uuid;
    //   this.mode = 'reprint'
    //   if(confirm("Do you want to reprint QR ?",true)){
    //     const routeData = this.$router.resolve({name: 'QR Print', query: {id: this.form.ikid_id, mode: this.mode}, });
    //     window.open(routeData.href, '_blank');
    //   }
    // },

    async reprint(uuid) {
      this.form.ikid_id = uuid;
      this.mode = 'reprint'
        // const routeData = this.$router.resolve({name: 'QR Print', query: {id: this.form.ikid_id, mode: this.mode}, });
        // window.open(routeData.href, '_blank');

        await ikid.getIkidbyID(uuid)
        .then(res => {
            this.name = '<h4>'+res.data.firstname+' '+res.data.lastname+'</h4>';
            this.id = res.data.barcode
            this.class = res.data.ikid_class.name
            this.check_time = moment(res.data.checkin_status.log_time).format ('DD/MM/YYYY HH:mm:ss')
            this.barcode = res.data.barcode
            // this.qr = 'https://x.ifgfsby.org/api/getqrcode/' + uuid;
            // this.qr_image = '<img src="'+this.qr+'" width="125" height="auto"/>';
            // this.qr_image = '<img src="data:image/png;base64,' + this.qr + '" width="125" height="auto"/>';

            this.connectToPrinter(res.data.firstname, res.data.lastname, res.data.ikid_class.name, res.data.barcode)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

        // const qrCanvas = document.createElement('canvas');
        // // add # for end of value to prevent double input
        // const qrCodeValue = this.barcode+'#';

        // QRCode.toCanvas(qrCanvas, qrCodeValue, (error) => {
        //   if (error) {
        //     console.error(error);
        //     return;
        //   }

        //   const qrCodeImage = qrCanvas.toDataURL('image/png');

        //   const newWindow = window.open('', '_blank');
        //   // newWindow.document.write('<html><head><title>New Tab</title></head><body>');
        //   // newWindow.document.write('<h3>IFGF KID</h3>');
        //   // newWindow.document.write('<h3>PICK UP CARD</h3>');
        //   // newWindow.document.write(this.name);
        //   // newWindow.document.write('<img src="' + qrCodeImage + '" width="125" height="auto" />');
        //   // newWindow.document.write('</body></html>');
        //   // newWindow.document.close();

        //   newWindow.document.write('<div style="width: fit-content; padding: 10px; border-radius: 4px; border: solid 1px #ccc; text-align: center;">');
        //   newWindow.document.write('    <div style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">IFGF KID PICK-UP CARD</div>');
        //   newWindow.document.write('    <strong>'+this.name+'</strong>');
        //   // newWindow.document.write('    ID : '+this.id+' <br>');
        //   newWindow.document.write('    Class : '+this.class+' <br>');
        //   newWindow.document.write('    Check In : '+this.check_time+'');
        //   newWindow.document.write('    <hr>');
        //   newWindow.document.write('    <center>');
        //   // newWindow.document.write('        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGkAAABpAQMAAAADTJ95AAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAPhJREFUOI2tlDEShCAMReNYWHIEj8LNZDuvtTN7EbkBJQWzfxNA1M7gMmP0NV/yf4DAK/DzkY8X/RET0Rjg8QlERouWv0SKy44T4tiPVynfj7hiItOPtqG0nyyXw427mG0XqVMKT/BIMC8g0mndRYCcSAFpyMrPEAVtwWVepSQbSY0OFaVBMXHaaOE8jBL38L5zDdS8c5nXTYvZcUZpUdDHUTbnQv6RHtMQ3SnBgl6LZRi8vBryWeB+N9ODJcLtGODoxE5SYr0ZgNVHaieUmx368ZASCzgU6kE5kvXq2zHkMdMjz8HlFgWPCpobd7HaLlKnFHiTiZT4Ay+lhgqFdJUHAAAAAElFTkSuQmCC" alt="Aaron Bradley Wu Barcode">');
        //   newWindow.document.write('<img src="' + qrCodeImage + '" width="175" height="auto" />');
        //   newWindow.document.write('    </center>');
        //   newWindow.document.write('    <div style="font-size: 14px; font-weight: bold; color: red; margin-bottom: 10px;">REPRINT</div>');
        //   newWindow.document.write('</div>');
        //   newWindow.document.close();

        //   newWindow.onload = function() {
        //     newWindow.print();
        //   };

        // });

        // const newWindow = window.open('', '_blank');
        // newWindow.document.write('<html><head><title>New Tab</title></head><body>');
        // newWindow.document.write('<h3>IFGF KID</h3>');
        // newWindow.document.write('<h3>PICK UP CARD</h3>');
        // newWindow.document.write(this.name);
        // // newWindow.document.write(this.qr_image);
        // newWindow.document.write('<img src="' + barcodeImage + '" width="125" height="auto" />');
        // newWindow.document.write('</body></html>');
        // newWindow.document.close();
    },

      async connectToPrinter(firstname, lastname, class_id, barcode) {
        // const firstname = firstname;
        // const lastname = lastname;
        // const class_id = class_id;
        const check_time = moment().format('DD/MM/YYYY HH:mm:ss');
        // const barcode = barcode + '#';

        try {
          const response = await axios.post('http://localhost:3000/print', {
            firstname: firstname,
            lastname: lastname,
            class_id: class_id,
            check_time: check_time,
            barcode: barcode
          },
          {
            timeout: 5000, // Timeout set to 5000ms (5 seconds)
          });
        } catch (error) {
          console.log('Error connecting to printer:', error);
          console.log('ID:', id);
        }
      },

    openCheckOut: function(uuid) {
      if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 4;
        ikid.changeStatusKid(this.form)
        .then(res => {
        EventBus.$emit('TABLE_UPDATE_IKIDS_CHECK', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    openForceCheckOut: function(uuid) {
      if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 3;
        ikid.changeStatusKid(this.form)
        .then(res => {

          setTimeout(() => {
            this.form.ikid_id = uuid;
            this.form.status = 4;
            ikid.changeStatusKid(this.form)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE_IKIDS_CHECK', true)
              // var params = {title: 'Success', mode:'success', data:res.message}
              // EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }, 1000);


        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    openCancelStatus: function(uuid, stat) {
      if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = stat;
        ikid.cancelStatusKid(this.form)
        .then(res => {
        EventBus.$emit('TABLE_UPDATE_IKIDS_CHECK', true)
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    openForceCancelStatus: function(uuid, stat) {
      if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = stat;
        ikid.cancelStatusKid(this.form)
        .then(res => {

          setTimeout(() => {
            this.form.ikid_id = uuid;
            this.form.status = stat-1;
            ikid.cancelStatusKid(this.form)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE_IKIDS_CHECK', true)
              // var params = {title: 'Success', mode:'success', data:res.message}
              // EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }, 1000);

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    async loadClass(){
      await ikid.getAllClass(this.$route.query.Pud).then((res) => {
          this.datas = res;
          this.listclass = res.data
      });
    },
    async loadGrade(){
      await ikid.getIkidGradeAll().then((res) => {
          this.listgrade = res.data
      });
    },
    loadData() {
      this.kid_class_id = this.listclass.find(item => item.name === this.ikid_class_name)?.id || 0
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        checkin_status:this.checkin_status,
        ikid_class_name: this.ikid_class_name,
        kid_class_id:this.kid_class_id,
      }

      var paramsLog = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_pageLog,
        per_page: this.per_pageLog,
        sortby: this.sortByLog,
        sortbydesc: this.sortByDescLog ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      ikid.getIkidDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active,
              checkin_status:this.checkin_status,
              ikid_class_name: this.ikid_class_name,
              kid_class_id:this.kid_class_id,
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      ikid.getIkidActivity(paramsLog)
      .then(res => {
          let getData = res.data
          this.itemsLog = getData.data
          //this.is_active = res.is_active
          this.metaLog = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active,

          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })


    },

    showIkidMonthlyReportAttendance () {
      let query = {};

      if (this.report_start_date !== '' && this.report_end_date !== '') {
          query.report_start_date = this.report_start_date;
          query.report_end_date = this.report_end_date;
      } else {
        alert('Please select start date and end date');
        return false;
      }

      query.report_class_id = this.report_class_id;
      query.report_grade_id = this.report_grade_id;
      query.report_service_type = this.report_service_type;

      let route = this.$router.resolve({
          path: '/reportview/ikid_attendance',
          query: query
      });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, '_blank', "height=800,width=1000");
    },

    handlePerPage(val) {
        this.per_page = val
        this.loadData()
    },

    handlePagination(val) {
        this.current_page = val
        this.loadData()
    },

    handlePerPageLog(val) {
        this.per_pageLog = val
        this.loadData()
    },

    handlePaginationLog(val) {
        this.current_pageLog = val
        this.loadData()
    },

    handleSearch(val) {
        this.search = val
        this.current_page = 1
        this.loadData()
    },

    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByLog = val.sortBy
        this.sortByDesc = val.sortDesc
        this.sortByDescLog = val.sortDesc
        this.loadData()
    },

    handleIsActive(val) {
        this.is_active = val
        this.loadData()
    },

    handleStatus(val) {
        this.checkin_status = val
        this.loadData()
    },

     handleClassFilter(val) {
        this.ikid_class_name = val;
        this.meta.ikid_class_name = val;
        this.loadData()
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleCheckin(val,ikid_id) {
        this.openCheckin(val,ikid_id)
    },
    handlePresent(val,ikid_id) {
        this.openPresent(val,ikid_id)
    },
    handleInclass(val,ikid_id) {
        this.openInclass(val,ikid_id)
    },
    handleQueue(val,ikid_id) {
        this.openQueue(val,ikid_id)
    },
    handleCheckOut(val,ikid_id) {
        this.openCheckOut(val,ikid_id)
    },
    handleForceCheckOut(val,ikid_id) {
        this.openForceCheckOut(val,ikid_id)
    },
    handleCancelStatus(val,stat) {
        this.openCancelStatus(val,stat)
    },
    handleForceCancelStatus(val,stat) {
        this.openForceCancelStatus(val,stat)
    },
    handleReactivate(val) {
        this.deactivate(val)
    },
    handleReprint(val,ikid_id) {
        this.reprint(val,ikid_id)
    },

  }
}
</script>
<style>
  .table_ikid_report {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
  }
  .table_ikid_report th:nth-child(1),
  .table_ikid_report td:nth-child(1),
  .table_ikid_report th:nth-child(4),
  .table_ikid_report td:nth-child(4) {
    border-right: 1px solid black;
  }
</style>
